import { render, staticRenderFns } from "./report-issue-details.vue?vue&type=template&id=6f07c0d3&"
import script from "./js/report-issue-details.js?vue&type=script&lang=js&"
export * from "./js/report-issue-details.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports